import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { DatalayerService } from "@edp-services/datalayer.service";
import { Observable, of } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class DatalayerResolver implements Resolve<Observable<void>> {
    constructor(private datalayerService: DatalayerService) {}

    resolve(route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Observable<void> {
        this.datalayerService.pageViewEvent(routerState.url, true);

        return;
    }
}
